import React,{useEffect} from "react";
import {Link } from "react-router-dom";
import Carousel from 'react-bootstrap/Carousel';
import check from "../images/check.png";
const React_Development = () =>
{

return(
<>
<div className="web-page">
  <section className="">
    <div className="container px-0">
      <div className="row xs-column-reverse  align-items-stretch">
        <div className="col-md-6 align-self-center">
          <div className="techUse-title">
            <h1><span className="sub-color">ReactJS </span>Development</h1>
          </div>
          <p>At BFC Softtech, we follow a structured development approach to ensure the best possible outcomes for our clients. Continue reading to figure out how our ReactJS Development Process sets us apart from the competition.</p>
          <Link to="/contact" className="btn btn-s">
          Let's Talk
          </Link>
        </div>
        <div className="col-md-6">
          <img src="../assets/img/solutions/react.jpg" alt="" srcset="" className="img-fluid" />
        </div>
      </div>
    </div>
  </section>
  <section className="work-process py-5">
    <div className="container px-0">
      <div className="row">
        <div className="col-md-12">
          <div className="techUse-title text-center ">
            <h1>Our <span className="sub-color"> ReactJS
              </span> Development Process 
            </h1>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-12 text-center">
          <img src="../assets/img/solutions/IT Process.png" className="img-fluid" alt="" />
        </div>
      </div>
    </div>
  </section>
  <section className="py-lg-5">
    <div className="container px-0">
      <div className="row justify-content-center pt-4">
        <div className="col-md-12 text-center">
          <div className="techUse-title text-center">
            <h1>Benefits of Opting for  <span className="sub-color"> ReactJS Development</span> 
            </h1>
          </div>
          <p className="short-desc">Opting for ReactJS Development can bring several benefits to businesses, including improved user experience and cost-effectiveness. Continue reading to understand these benefits better: </p>
        </div>
      </div>
      <div className="row why-go pb-4">
        <div className="col-md-4 ml-3 ba">
          <span>
          <div className="hover-icon">
          <img src={check} alt="" srcset="" className="img-fluid" />
            <h4 className="color-bluec pt-3">Quick Deployment & Market Access </h4>
            <p>
            ReactJS development facilitates faster development and deployment of web applications. Features like virtual DOM and reusable components allow efficient coding, reducing the time and effort needed to develop web applications. As a result, businesses can launch their products or services much faster.
            </p>
          </div>
          </span>
        </div>
        <div className="col-md-4 ml-3 ba">
        <span>
          <div className="hover-icon">
          <img src={check} alt="" srcset="" className="img-fluid" />
            <h4 className="color-bluec pt-3">Better User Experience</h4>
            <p>
            ReactJS facilitates improved performance, resulting in a better loading time and smoother user experiences, leading to greater customer satisfaction and amplified user engagement.
            </p>
          </div>
          </span>
        </div>
        <div className="col-md-4 ml-3 ba">
        <span>
          <div className="hover-icon">
          <img src={check} alt="" srcset="" className="img-fluid" />
            <h4 className="color-bluec pt-3">Easy Scalability </h4>
            <p>
            ReactJS allows for the creation of scalable web applications through modular and reusable components. This makes maintenance and updates much easier, as businesses can keep adding new features to their applications.
            </p>
          </div>
          </span>
        </div>
        {/* <div className="col-md-4 ml-3 ba">
        <span>
          <div className="hover-icon">
          <img src={check} alt="" srcset="" className="img-fluid" />
            <h4 className="color-bluec pt-3">Cost-Effectiveness </h4>
            <p>
            ReactJS reduces the time and effort required to develop web applications, in turn reducing development costs.
            </p>
          </div>
          </span>
        </div> */}
       
      </div>
    </div>
  </section>
  <section>
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-md-12">
          <div className="techUse-title text-center">
            <h1>  Why Choose <span className="sub-color">BFC Softtech</span> as your <span className="sub-color"> ReactJS Development </span> Company?
               
            </h1>
          </div>
        </div>
        <div className="col-md-12 text-center ">
          <p className="short-desc">BFC Softtech is the ideal choice for businesses looking for high-quality and scalable ReactJS development solutions. Our services are cost-effective solutions, and our development process well-structured. Continue reading to figure out how we can help you take your business online. </p>
        </div>
      </div>
      <div className="row py-5">
        <section className="web-banner mb-4">
          <Carousel>
            <Carousel.Item interval={2000}>
              <div className="banner-content">
                <div className="container px-0">
                  <div className="row">
                    <div className="col-lg-5">
                      <div className="banner-img">
                        <div className="">                       
                          <img src="../assets/img/solutions/dev.jpg" className="img-fluid" alt="" />                           
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-7 d-flex align-items-stretch ">
                      <div className="align-self-center">
                        <div className="banner-content">
                          <div className="banner-title pt-3">
                            <h4 className="color-bluec ">Proves Expertise
                            </h4>
                          </div>
                          <div className="banner-disc">
                            <p className="">Over the years, we have helped businesses across industries find online success by developing quality and highly functional web applications. Our team is a brilliant blend of experience and skill, making us an ideal development partner for businesses of all sizes.</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Carousel.Item>
            <Carousel.Item interval={2000}>
              <div className="banner-content">
                <div className="container px-0">
                  <div className="row">
                    <div className="col-lg-5">
                      <div className="banner-img">
                        <div className="">                       
                          <img src="../assets/img/solutions/new/outs.jpg" className="img-fluid" alt="" />                           
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-7 d-flex align-items-stretch">
                      <div className="align-self-center">
                        <div className="banner-content">
                          <div className="banner-title">
                            <h4 className="color-bluec ">Well-Structured Development Process
                            </h4>
                          </div>
                          <div className="banner-disc">
                            <p className="">We have a carefully structured development process, which starts with understanding the client's requirements and ends with a quality, professionally-developed output.</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Carousel.Item>
            <Carousel.Item interval={2000}>
              <div className="banner-content">
                <div className="container px-0">
                  <div className="row">
                    <div className="col-lg-5">
                      <div className="banner-img">
                        <div className="">                       
                          <img src="../assets/img/solutions/new/solutions.jpg" className="img-fluid" alt="" />                           
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-7 d-flex align-items-stretch">
                      <div className="align-self-center">
                        <div className="banner-content">
                          <div className="banner-title">
                            <h4 className="color-bluec ">Affordable Solutions
                            </h4>
                          </div>
                          <div className="banner-disc">
                            <p className="">At BFC Softtech, we believe in providing cost-effective development solutions suited to all types of clients without compromising on quality and functionality. Consequently, our pricing plans are flexible, with clients paying only for their desired services.</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Carousel.Item>
            <Carousel.Item interval={2000}>
              <div className="banner-content">
                <div className="container px-0">
                  <div className="row">
                    <div className="col-lg-5">
                      <div className="banner-img">
                        <div className="">                       
                          <img src="../assets/img/solutions/expert.jpg" className="img-fluid" alt="" />                           
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-7 d-flex align-items-stretch">
                      <div className="align-self-center">
                        <div className="banner-content">
                          <div className="banner-title">
                            <h4 className="color-bluec ">Collaborative Approach
                            </h4>
                          </div>
                          <div className="banner-disc">
                            <p className="">We work closely with our clients so we can understand their business goals and design solutions that address their exact needs.</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Carousel.Item>
          </Carousel>
        </section>
      </div>
    </div>
  </section>
  
</div>
</>
)
}
export default React_Development